"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneOf = OneOf;
const class_validator_1 = require("class-validator");
let OneOfConstraint = class OneOfConstraint {
    validate(value, args) {
        const properties = args.constraints;
        const object = args.object;
        const values = properties.map((property) => object[property]).filter((val) => val);
        return values.length === 1;
    }
    defaultMessage(args) {
        const properties = args.constraints.join(', ');
        return `One and only one of the following properties must be provided: ${properties}.`;
    }
};
OneOfConstraint = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ async: false })
], OneOfConstraint);
function OneOf(properties, validationOptions) {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            constraints: properties,
            options: validationOptions,
            propertyName: propertyName,
            target: object.constructor,
            validator: OneOfConstraint,
        });
    };
}
//# sourceMappingURL=ValidatorHelpers.js.map